export default __webpack_public_path__ + "static/media/curation1.0f63e72c.wav";